/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ChangeEvent } from 'react'
import { FaUser } from 'react-icons/fa'
import { Image, Form } from 'react-bootstrap'
import CompanyImg from '../../../../../assets/img/gray_logo_icon.svg'
import { RelatedProspect as RelatedProspectType } from '../../../../../stores/related'
import ContactInfo from '../ContactInfo'
import ManeuverStatus from '../../../ManeuverStatus'
import './styles.scss'

interface Props {
  prospect: RelatedProspectType
  setCurrentUser: React.Dispatch<any>
  onSendToMarketingChange: (checked: boolean) => void
  onActivateManeuverChange: (checked: boolean) => void
  onProspectDNCChange: (checked: boolean) => void
}

const Relates: FC<Props> = ({
  prospect,
  setCurrentUser,
  onSendToMarketingChange,
  onActivateManeuverChange,
  onProspectDNCChange,
}) => {
  const sendToMarketingChecked = prospect['SEND TO MARKETING'] === 'true'
  const dncChecked = prospect.DNC === 'true'
  const status = prospect.STATUS.toLowerCase()
  let activateManeuverChecked = false

  if (status === 'activated' || status === 'email scheduled' || status === 'active') {
    activateManeuverChecked = true
  }
  return (
    <div className={`prospect ${prospect.email}`}>
      <div className="relates-body">
        <div
          role="button"
          tabIndex={0}
          onKeyDown={(): void => {}}
          className="avatar-section"
          onClick={(): void => setCurrentUser(prospect)}
        >
          {prospect.addedBy === 'User' ? (
            <div className="avatar-icon">
              <FaUser />
            </div>
          ) : (
            <Image src={CompanyImg} alt="Placeholder" className="avatar" roundedCircle />
          )}
          <div className="name-section">
            <p className="name">{prospect.firstName}</p>
            <p className="name">{prospect.lastName}</p>
          </div>
        </div>
        <div className="content-section">
          <p className="title">{prospect.title}</p>
          <ContactInfo
            company={prospect.company}
            domain={prospect.domain}
            email={prospect.email}
            phone={prospect.phoneNumber?.number}
          />
          <div className="status">
            <ManeuverStatus
              maneuver={prospect.Maneuver}
              customSendDate={new Date(prospect['SEND DATE']).getTime()}
            />
          </div>
          <div className="switches">
            <Form.Check
              className="switch"
              id={`send-prospect-to-marketing-${prospect.email}`}
              type="switch"
              label={sendToMarketingChecked ? 'Sent To Marketing' : 'Send Contact To Marketing'}
              checked={sendToMarketingChecked}
              onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                onSendToMarketingChange(e.target.checked)
              }}
            />
            <Form.Check
              className="switch"
              id={`activate-maneuver-${prospect.email}`}
              type="switch"
              label={activateManeuverChecked ? 'Maneuver Activated' : 'Maneuver Inactive'}
              checked={activateManeuverChecked}
              onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                onActivateManeuverChange(e.target.checked)
              }}
            />
            <Form.Check
              className="switch"
              id={`prospect-on-dnc-${prospect.email}`}
              type="switch"
              label={dncChecked ? 'Do Not Engage Prospect' : 'Do Not Engage Prospect'}
              checked={dncChecked}
              onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                onProspectDNCChange(e.target.checked)
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Relates
